import React from "react";
import SkillStyle from "../../style/body/Skill.module.css";
import SkillComponent from "./helper-component/skill";
import HeadLine from "./helper-component/HeadLine";

const Skill = () => {
  const programming = {
    "C++": "assets/icons/skills/cpp.svg",
    JavaScript: "assets/icons/skills/js.svg",
    PHP: "assets/icons/skills/php.svg",
    TypeScript: "assets/icons/skills/ts.svg",
    GO: "assets/icons/skills/go.svg",
  };
  const frontend = {
    HTML: "assets/icons/skills/html.svg",
    CSS: "assets/icons/skills/css.svg",
    Bootstrap: "assets/icons/skills/bootstrap.svg",
    "React JS": "assets/icons/skills/react.svg",
  };
  const backend = {
    "Node JS": "assets/icons/skills/nodejs.svg",
    "Express JS": "assets/icons/skills/express.svg",
    Laravel: "assets/icons/skills/laravel.svg",
    HyperLedger: "assets/icons/skills/hyperledger.svg",
  };
  const advancedBackend = {
    "Socket.io": "assets/icons/skills/socket.svg",
    Firebase: "assets/icons/skills/firebase.svg",
    Clustering: "assets/icons/skills/cluster.png",
    PM2: "assets/icons/skills/pm2.svg",
    Prometheus: "assets/icons/skills/prometheus.svg",
    Grafana: "assets/icons/skills/grafana.svg",
  };
  const database = {
    MySQL: "assets/icons/skills/mysql.svg",
    MongoDB: "assets/icons/skills/mongodb.svg",
    Redis: "assets/icons/skills/redis.svg",
    "Apache Kafka": "assets/icons/skills/kafka.svg",
  };
  const devops = {
    Jenkins: "assets/icons/skills/jenkins.svg",
    Ansible: "assets/icons/skills/ansible.svg",
    Terraform: "assets/icons/skills/terraform.svg",
    Docker: "assets/icons/skills/docker.svg",
    "Graylog": "assets/icons/skills/graylog.svg",
    "Apache JMeter": "assets/icons/skills/jmeter.svg",
  };
  const media = {
    Flussonic: "assets/icons/skills/flussonic.png",
    CDN: "assets/icons/skills/cdn.svg",
  }
  const cloud = {
    Nginx: "assets/icons/skills/nginx.svg",
    AWS: "assets/icons/skills/aws.svg",
    EC2: "assets/icons/skills/aws_ec2.svg",
    "Load Balance": "assets/icons/skills/loadbalancing.svg",
    S3: "assets/icons/skills/aws_s3.svg",
    Cloudfront: "assets/icons/skills/cloudfront.svg",
  };
  const research = {
    Mendeley: "assets/icons/skills/mendeley.svg",
    Latex: "assets/icons/skills/latex.svg",
  };
  const miscellaneous = {
    Git: "assets/icons/skills/git.svg",
    Linux: "assets/icons/skills/linux.svg",
    Bash: "assets/icons/skills/bash.svg",
    "MS Office": "assets/icons/skills/ms-office.svg",
    "Draw.io": "assets/icons/skills/drawIO.svg",
  };
  return (
    <div className="container">
      <HeadLine title="#PROGRAMMING" typography="Programming" />
      <SkillComponent images={programming} />
      <HeadLine title="#FRONTEND" typography="Frontend" />
      <SkillComponent images={frontend} />
      <HeadLine title="#BACKEND" typography="Backend" />
      <SkillComponent images={backend} />
      <HeadLine title="#Advanced Backend" typography="Backend" />
      <SkillComponent images={advancedBackend} />
      <HeadLine title="#DATABASE" typography="Databases" />
      <SkillComponent images={database} />
      <HeadLine title="#DevOps" typography="Devops" />
      <SkillComponent images={devops} />
      <HeadLine title="#Media" typography="Media" />
      <SkillComponent images={media} />
      <HeadLine title="#CLOUD SERVICES" typography="Cloud Services" />
      <SkillComponent images={cloud} />
      <HeadLine title="#RESEARCH TOOLS" typography="Research Tools" />
      <SkillComponent images={research} />
      <HeadLine title="#MICELLANEOUS" typography="Miscellaneous" />
      <SkillComponent images={miscellaneous} />
      <HeadLine title="#MY SOFT SKILLS" typography="Soft Skills" />
      <div className={`row ${SkillStyle.soft_skill}`}>
        <div className={`col-md-8 col-12 ${SkillStyle.soft_skill_div}`}>
          <div className={` ${SkillStyle.items}`}>
            <p className={` ${SkillStyle.mr}`}>Time Management</p>
            <p className={` ${SkillStyle.mr}`}>Team Work</p>
            <p>Problem Solving</p>
          </div>
          <div className={` ${SkillStyle.items}`}>
            <p className={` ${SkillStyle.mr}`}>Documentation</p>
            <p>Engaging Presentation</p>
          </div>
        </div>
        <div className={`col-md-1 ${SkillStyle.dot_icon}`}>
          <img src="assets/icons/skills/dot_icon.svg"></img>
        </div>
        <div className={`col-md-3 ${SkillStyle.logo_icon}`}>
          <img src="assets/icons/skills/soft-skill.svg"></img>
        </div>
      </div>
    </div>
  );
};

export default Skill;
